<app-loader [isLoading]="isLoading$ | async"></app-loader>
<ng-container *ngLet="(screenSizeService.isHandset$ | async) as isHandset">
  <mat-sidenav-container
    *ngLet="(isFullScreenMode$ | async) as isFullScreenMode"
    fullscreen
    autosize
    [hasBackdrop]="isSidebarOpen && screenWidth <= 1024"
    [ngClass]="{'sidenav-expanded': isSidebarOpen, 'sidenav-pinned': (isSidebarOpen && screenWidth > 1024), 'sidenav-hidden': isFullScreenMode}"
    (backdropClick)="toggleSidebar()"
  >
    <mat-sidenav
      class="invert-theme"
      [ngClass]="{ 'isHandset': isHandset }"
      [hidden]="isFullScreenMode"
      [mode]="isSidebarOpen ? ((screenWidth > 1024) ? 'side' : 'over') : 'over' "
      opened
      [fixedInViewport]="true"
      disableClose
    >
      <app-sidebar [isHandset]="isHandset"></app-sidebar>
    </mat-sidenav>
    <!-- main-container class needed for the infinite scroll -->
    <mat-sidenav-content class="main-container" [ngClass]="{ 'isHandset': isHandset }">
      <app-header [isHandset]="isHandset" [hidden]="isFullScreenMode" id="app-header"></app-header>
      <router-outlet></router-outlet>
      <button
        *ngIf="isFullScreenMode"
        mat-flat-button
        class="floatingFullScreenButton"
        i18n="@@shared.mainLayout.fullScreenExitBtn"
        (click)="toggleFullScreenMode()"
      >
        <span>Exit Full Screen</span>
      </button>
    </mat-sidenav-content>
  </mat-sidenav-container>
</ng-container>
